module.exports = __webpack_public_path__ + "static/media/meh-rolling-eyes.231677f1.svg";